import React from 'react';
import './AboutUS.css';

const AboutUs = () => {
    return (
        <div className="about-us-container">
            <h1>About Us</h1>
            <p>Welcome to JoshMach Pharmacy, where our dedication to patient-centered care is the cornerstone of our services. Nestled in the serene surroundings of Kikambala at Sultan Apartment Junction, we are more than just a pharmacy – we are your trusted healthcare partner.</p>
            
            <h2>Mission</h2>
            <ul>
                <li><strong>Patient-Centered Care:</strong> Putting our patients at the heart of everything we do, ensuring personalized and attentive service.</li>
                <li><strong>Accurate Prescription Handling:</strong> Meticulously managing prescriptions to guarantee safe and effective medication use.</li>
                <li><strong>Expert Prescription Evaluation:</strong> Carefully evaluating each prescription to ensure its appropriateness and safety for our patients.</li>
                <li><strong>Comprehensive Medication Solutions:</strong> Providing a wide range of medications, from prescriptions to over-the-counter drugs, tailored to meet your health needs.</li>
            </ul>
            
            <h2>Vision</h2>
            <p>To be the leading pharmacy recognized for our superior patient care, innovative solutions, and unwavering commitment to health and wellness. We envision a community where every individual has access to quality healthcare and personalized pharmaceutical services, fostering a healthier and happier future for all.</p>
            
            <p>At JoshMach Pharmacy, your health is our priority. Let us be your partner in wellness, offering the care and expertise you deserve.</p>
        </div>
    );
};

export default AboutUs;
